import { createSelector } from '@ngrx/store'
import { AppState } from '../app.state'
import { HandlerState } from './handler.state'

export const getHandler = (state: AppState) => state.handler

export const showSpinner = createSelector(getHandler, (state: HandlerState) => state.showSpinner)
